const ENDPOINTS = {
  SERVER_SIDE_TYR: '/serverside_tyr.php',
  SERVER_SIDE_2_TYR: '/serverside_2_tyr.php',
};

export default ENDPOINTS;
